import React from "react";
import "./index.css";
import Container from "../Container/Index";
import Swiperslider from "../Swiperslider/Index";
import ImageTag from "../ImageTag/Index";
import Title from "../Title/Index"

const Featureslider = ({ Data, slidesPerView, secondSlider, spaceBetween, ImageWidth, ImageHeight }) => {
  return (
    <>
      <Container containerClass={'float-end'}>
        <div className="col-12 flaot-start p-0">
        <div className="col-lg-6 col-sm-12 col-12 m-auto">
          {Data && (
            <Title
              firstHeading={Data.title}
              secondHeading={Data.heading}
            />
          )}
        </div>
        <div className={`featureSlider ${secondSlider} bottomPosition p-0`}
          data-aos="fade-in"
          data-aos-offset="200"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"
        >
          <Swiperslider slidesPerView={slidesPerView} spaceBetween={spaceBetween} navigation={true} timeDelay={'6000'} tabspaceBetween={15} loop={false}>
            {Data.featureData.map((logo, index) => (
              <div className="col-12 position-relative featureSlide h-100 flex-center p-0"
                key={index} >
                <div className="row flex-center sliderRow m-0 h-100">
                  <div className="col-lg-6 col-12 p-0 h-100">
                    {logo.imagePath ? (<ImageTag ImagePath={logo.imagePath} ImageAlt={logo.imageAlt} ImageWidth={ImageWidth} ImageHeight={ImageHeight}/>
                    ) : (
                      <div className='col-12 float-start Noimage flex-center h-100 p-0'>
                        <ImageTag ImageAlt={'No Image Found'} />
                      </div>
                    )}
                  </div>
                  {logo.imageAlt ? (
                    <div className="col-lg-6 col-12 p-0 sldierContent">
                      <div className="infoManufac">
                        <div className="col-lg-11 m-auto col-12 cardStnComponent h-auto p-0">
                          <span className="featureName text-uppercase fw-bold position-relative">{logo.imageAlt}</span>
                          {Array.isArray(logo.description) && logo.description.length > 0 ? (
  <ul className="mt-2 d-grid gap-0">
    {logo.description.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
) : (
  <p className="m-0">No description available.</p>
)}
                        </div>
                      </div>
                    </div>
                  ) : (
                    null
                  )}
                </div>
              </div>
            ))}
          </Swiperslider>
        </div>
        </div>
      </Container>
     
    </>
  );
};

export default Featureslider;